module.exports = __webpack_public_path__ + "media/images/lp/logo-87f623969908ffc7711c93936e349c75.svg";